/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_More_Stats_Well_PacedInputs */

const en_ui_more_stats_well_paced = /** @type {(inputs: Ui_More_Stats_Well_PacedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Well paced`)
};

const de_ui_more_stats_well_paced = /** @type {(inputs: Ui_More_Stats_Well_PacedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gleichmäßig`)
};

/**
* | output |
* | --- |
* | "Well paced" |
*
* @param {Ui_More_Stats_Well_PacedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_more_stats_well_paced = /** @type {((inputs?: Ui_More_Stats_Well_PacedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_More_Stats_Well_PacedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_more_stats_well_paced(inputs)
	return de_ui_more_stats_well_paced(inputs)
});